export const PRACTICE_REQUEST = 'PRACTICE_REQUEST'
export const PRACTICE_REQUEST_SUCCESS = 'PRACTICE_REQUEST_SUCCESS'
export const PRACTICE_REQUEST_ERROR = 'PRACTICE_REQUEST_ERROR'
export const PRACTICE_CHECK = 'PRACTICE_CHECK'
